"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = void 0;
var react_1 = __importDefault(require("react"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var Track = function Track(props) {
  var included = props.included,
    vertical = props.vertical,
    offset = props.offset,
    length = props.length,
    className = props.className;
  var style = {
    visibility: included ? 'visible' : 'hidden'
  };
  if (vertical) {
    style.bottom = offset + "%";
    style.height = length + "%";
  } else {
    style.left = offset + "%";
    style.width = length + "%";
  }
  return react_1.default.createElement("div", {
    className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('slider__track'), className),
    style: style
  });
};
exports.Track = Track;
exports.Track.displayName = 'Track';